import type { ISelectListItem } from "@ui/ui.types";

export const APPROVER_DAYS_LIST = Array.from(
  Array(12).keys()
).map<ISelectListItem>((el) => ({
  label: `${el + 1} bookings`,
  value: el + 1
}));
